import { Field, useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const OptionalDonationSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Optional: Support the Old Vine Registry</h2>
      <p className="form-fields-sub-text" style={{ marginBottom: "18px" }}>
        The US $300 registration fee supports administration of the OVR Seal
        program. You may also make an optional, tax deductible* donation to
        support the Old Vine Registry's broader work to identify, document, and
        celebrate old vineyards.
      </p>

      <div className="seal-donation-options">
        {[
          { value: "none", label: "No additional donation" },
          { value: "50", label: "US $50" },
          { value: "100", label: "US $100" },
          { value: "250", label: "US $250" },
          { value: "other", label: "Other amount" },
        ].map((option) => (
          <BsForm.Check
            key={option.value}
            type="radio"
            label={option.label}
            className="checkbox-label-text"
            name="donationOption"
            checked={values.donationOption === option.value}
            onChange={() => setFieldValue("donationOption", option.value)}
          />
        ))}

        {values.donationOption === "other" && (
          <div className="seal-donation-other-input">
            <span style={{ fontFamily: "'Alegreya Sans', sans-serif", fontSize: "16px" }}>
              US $
            </span>
            <Field
              name="donationOtherAmount"
              type="number"
              min="0"
              step="1"
              placeholder="0"
              className="input-text"
              style={{ width: "120px", height: "44px" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
